var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileInputIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 97,
    viewBox: "0 0 65 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5988 97H5.04956V55.283H24.3054L22.7624 61.1361L56.0531 69.9106L59.9086 55.283H62.5988V97Z",
    fill: "#3178B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3054 55.2833H5.04956V50.9633H25.3832L25.4138 51.0771L24.3054 55.2833Z",
    fill: "#3178B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6826 54.7823H7.05261V52.2685H23.6826V54.7823Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3733 60.78L55.6969 69.2996L64.2166 36.9759L31.8929 28.4563L23.3733 60.78Z",
    fill: "white",
    stroke: "#E2E2E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4482 97H4.89831L0.459473 58.7441H58.0093L62.4482 97Z",
    fill: "#5BABF3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3336 54.7823H0L0.45952 58.7441H21.9616L20.3336 54.7823Z",
    fill: "#369CF7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8795 36.9748L46.3087 29.7622L40.2227 1.55276L6.79354 8.76473L12.8795 36.9748Z",
    fill: "white",
    stroke: "#E2E2E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2793 24.504L27.9702 21.4425L32.7548 12.004L45.1341 21.9464L37.8501 23.5175L33.2793 24.504Z",
    fill: "#2A92EE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9584 28.2406L22.928 18.5345L33.2792 24.5038L15.9584 28.2406Z",
    fill: "#369CF7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4974 37.5726L10.7275 29.3689L45.1342 21.946L46.9041 30.1491L43.2598 30.9356L29.9665 33.8034L12.4974 37.5726Z",
    fill: "#3178B8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8168 19.109C13.7558 19.109 12.7655 18.4563 12.351 17.476C11.5946 15.6861 12.8543 13.7336 14.7968 13.6842C14.8186 13.6842 14.8405 13.6836 14.8624 13.6836C15.9234 13.6836 16.913 14.3369 17.3275 15.3166C18.084 17.1071 16.8249 19.0596 14.8818 19.1084C14.8599 19.109 14.838 19.109 14.8168 19.109Z",
    fill: "#3178B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileInputIcon);
export default __webpack_public_path__ + "static/media/file-input-icon.eeeb73d1b9a2150936f01ec1a8eaea16.svg";
export { ForwardRef as ReactComponent };